import React from 'react';

interface IConfig {
  currentRoles: string[];
  permissions: { [key: string]: string[] };
}

interface RoleKeeperProps {
  permission: string;
  children: React.ReactNode & { type: { name: string } };
}

type CanFunctionType = (permission: string) => boolean;

type RoleKeeperComponentType = React.FC<RoleKeeperProps>;

export const roleHook = (
  config: IConfig,
): [CanFunctionType, RoleKeeperComponentType] => {
  const { currentRoles, permissions } = config;

  const can = (permission: string) => {
    return permissions[permission].some(role => currentRoles.includes(role));
  };

  const RoleKeeper: React.FC<RoleKeeperProps> = props => {
    const { permission, children } = props;

    if (can(permission)) {
      return <>{children}</>;
    }

    if (
      React.isValidElement<{
        disabled?: boolean;
        onClick?: () => void;
        style?: React.CSSProperties;
      }>(children)
    ) {
      if (children.type.name.toLocaleLowerCase().includes('button')) {
        const clonedChildren = React.cloneElement(children, {
          disabled: true,
          onClick: () => null,
        });

        return <>{clonedChildren}</>;
      }

      const clonedChildren = React.cloneElement(children, {
        style: { filter: 'grayscale(1)' },
        onClick: () => null,
      });

      return (
        <span
          style={{ filter: 'blur(4px) grayscale(1)', pointerEvents: 'none' }}
        >
          {clonedChildren}
        </span>
      );
    }
  };

  return [can, RoleKeeper];
};
